import { createElement, useState } from "react";
import { useDotLegalSnackbar } from "@dotlegal/dotlegal-ui-components";
import { CreateEditEntityTemplateStepDialogProps } from "./CreateEditEntityTemplateStepDialog.tsx";
import { isNullOrWhitespace } from "../../../common/stringOperations.ts";
import { Trans } from "react-i18next";
import { post, put } from "../../../common/api/apiShared.ts";
import { useDotLegalMutation } from "@common/hooks/dotLegalReactQuery";

export function useCreateEditEntityTemplateStepDialog(props: CreateEditEntityTemplateStepDialogProps) {
    const snackbar = useDotLegalSnackbar();
    const [saveModel, setSaveModel] = useState<string>(props.step?.name ?? "");
    const [showError, setShowError] = useState<boolean>(false);

    const modelUpdater = {
        onStepNameChange: (name: string) => {
            setSaveModel(name);
        },
    };

    const createMutation = useDotLegalMutation(createEntityTemplateStep);
    const onCreateEntityTemplateStep = () => {
        createMutation.mutateAsync(undefined, {
            onSuccess: (result) => {
                if (result.success()) {
                    snackbar.show(createElement(Trans, { i18nKey: "itemCreatedSuccess", values: { name: saveModel } }));
                    props.onStepSaved();
                }
            },
        });
    };

    const editMutation = useDotLegalMutation(editEntityTemplateStep);
    const onEditEntityTemplateStep = () => {
        editMutation.mutateAsync(undefined, {
            onSuccess: (result) => {
                if (result.success()) {
                    snackbar.show(createElement(Trans, { i18nKey: "itemEditedSuccess", values: { name: saveModel } }));
                    props.onStepSaved();
                }
            },
        });
    };

    const onSaveStep = () => {
        if (isNullOrWhitespace(saveModel)) {
            setShowError(true);
            return;
        }

        if (props.step) {
            onEditEntityTemplateStep();
        } else {
            onCreateEntityTemplateStep();
        }
    };

    return {
        saveModel,
        onSaveStep,
        isSaving: editMutation.isLoading || createMutation.isLoading,
        showError,
        modelUpdater,
    };

    async function createEntityTemplateStep() {
        return await post(`/entity-templates/${props.entityTemplateId}/steps`, { stepName: saveModel });
    }

    async function editEntityTemplateStep() {
        return await put(`/entity-templates/${props.entityTemplateId}/steps/${props.step!.id}`, { stepName: saveModel });
    }
}
